const BaseCategoryPage = require( 'base/category-page' );
const Query = require( 'helper/query' );
const Server = require( 'helper/server' );
const ESClient = require( 'helper/es-client' );


const listTpl = Handlebars.templates[ 'common/mailBox/templates/list' ];
const letterDetail = Handlebars.templates[ 'common/mailBox/templates/letter-detail' ];

// 湖南站点id
const HNsiteid= new Array(15).fill(62).map((x,i) => (x+i).toString() );
const treeData = {
  name: '公开信箱',
  text: '公开信箱',
  children: [
    {
      name: '全部来信',
      text: '全部来信'
    },
    {
      id: 0,
      name: '业务咨询',
      text: '业务咨询'
    },
    {
      id: 1,
      name: '举报投诉',
      text: '举报投诉'
    },
    {
      id: 2,
      name: '意见建议',
      text: '意见建议'
    },
    {
      id: 3,
      name: '中标无效确认',
      text: '中标无效确认'
    },
    {
      id: 4,
      name: '其他',
      text: '其他'
    }
  ]
};

class mailBox extends BaseCategoryPage {
  init() {
    this.query = new Query();
    this.previewFlag = this.isFromPreview();
    this.pageNo = 1;
    this.pageSize = 15;
    this.type = null;
    this.isSubmit = true;
    this.client = new ESClient();
    this.$myModal = $( '#myModal' );
    this.$search = $( '#search' );
    this.$keyword = $( '#keyword' );
    this.site = $( '[name=siteId]' ).val();
    this.$searchModal = $( '#searchModal' );
    this.$detailModal = $( '#detailModal' );
    this.$writeNow = $( '.img-button' );
    this.$pictureInput = this.$myModal.find( '.picture-input' );
    this.$pictureCheck = this.$myModal.find( '#pictureCheck' );
    this.$submitMail = this.$myModal.find( '#submitMail' );
    this.$date = this.$searchModal.find( '.date' );
    this.$hlReset = this.$searchModal.find( '#hl-reset' );
    this.$hlSearch = this.$searchModal.find( '#hl-search' );
    this.$send = this.$myModal.find( '.send' );
    this.$highSearch = $( '.high-search' );
    this.$letterSearch = $( '.mail-search' );
    this.$iconShape = $( '.icon-Shape' );
    this.$telPhone = this.$myModal.find( '.telPhone' );
    this.$email = this.$myModal.find( '.email' );
    this.$reset = this.$myModal.find( '.reset' );
    this.$filesAdd = this.$myModal.find( '.files-add' );
    this.$addButton = this.$myModal.find( '.add-button' );
    this.$letterTr = this.$myModal.find( '.letter-tr' );
    this.$submitUploadForm = this.$myModal.find( '#submitUploadForm' );
    this.$letterFiles = this.$letterTr.find( '.letter-files' );
    this.$addLetterFiles = this.$letterTr.find( '.add-letter-files' );
    this.$cancel = this.$myModal.find( '.cancel' );
    this.$nav = this.$el.find( '.list__nav' );
    this.$navContent = this.$el.find( '.list__nav-content' );
    this.$content = this.$el.find( '.list__content' );
    this.$bread = this.$el.find( '.list__bread' );
    this.$letterList = $( '.block_main' );
    this.initSearchPanel = $.noop;
    this.clearSearch = $.noop;
    let newTree = this.treeData.children;
    if ( this.site === '61') {
      newTree =this.treeData.children.filter(x => x.id!==1);
    }
    if (HNsiteid.includes(this.site)) {
      newTree =this.treeData.children.filter(x => x.id!==3 && x.id!==4);
    }
    if ( this.site === '78') {
      newTree =this.treeData.children.filter(x => x.id!==3 && x.id!==4);
    }
    this.treeData.children=newTree;
    // console.log(this.treeData);
    const categoryTreeData = this.treeData;
    this.initTree( categoryTreeData );
    this.bindEvent();
  }

  bindEvent() {
    let here = this;
    // 点击取消时，重置文件样式事件
    here.$cancel.on( 'click', () => {
      here.changeFileBox( true );
    } );
    // 点击添加附件事件
    here.$addLetterFiles.on( 'click', () => {
      here.changeFileBox( false );
    } );
    // 获取文件名放置 input 框事件
    here.$letterFiles.on( 'change', '.file', ( e ) => {
      here.getFileName( e );
    } );
    // 删除文件事件
    here.$letterFiles.on( 'click', '.delete-file', ( e ) => {
      here.deleteFiles( e );
    } );
    // 添加文件选择行事件
    here.$addButton.on( 'click', () => {
      here.addRows();
    } );
    // 重置事件
    here.$reset.on( 'click', () => {
      here.resetModal();
    } );

    // 发送信件
    here.$submitMail.on( 'click', () => {
      if (this.isSubmit) {
        this.isSubmit = false;
        here.submitMail();
      }
    } );
    // 信件的搜索
    here.$letterSearch.on( 'input propertychange', '#keyword', ( e ) => {
      here.letterSearch( e );
    } );
    // 清空搜索框
    here.$iconShape.on( 'click', () => {
      here.clearSearchInput();
    } );
    // 点击高级搜索显示弹窗的时间插件加载
    here.$highSearch.on( 'click', () => {
      here.$keyword.val( '' );
      here.$date.datetimepicker( {
        format: 'yyyy-mm-dd',
        autoclose: true,
        maxView: 4,
        minView: 2,
        language: 'zh-CN'
      } );
    } );

    // 重置高级搜索弹窗事件
    here.$hlReset.on( 'click', () => {
      here.resetHighSearch();
    } );

    // 点击列表返回详情弹窗
    here.$letterList.on( 'click', '.a-title', ( e ) => {
      here.letterDetail( e );
    } );

    // 点击搜索图标进行普通搜索
    here.$search.on( 'click', () => {
      here.pageNo = 1;
      here.$searchModal.find( '#hl-keyword' ).val( '' );
      here.search();
    } );

    // 高级搜索
    here.$hlSearch.on( 'click', () => {
      here.pageNo = 1;
      here.search();
    } );

    // 回车进行普通搜索
    here.$keyword.keyup( ( e ) => {
      if (e.keyCode == 13) {
        here.pageNo = 1;
        here.$searchModal.find( '#hl-keyword' ).val( '' );
        here.search();
      }
    } );

    // 左侧模块分类搜索
    here.$navContent.on( 'click', '.jstree-children', () => {
      here.pageNo = 1;
      here.search();
    } );

    // 马上写信时初始化验证码和机构单位下拉框
    here.$writeNow.on( 'click', () => {
      here.$myModal.find( '.letter-org' ).empty();
      let time = new Date().getTime();
      let imgUrl = Server.urls.img + '?time=' + time;
      here.$pictureCheck.attr( 'src', imgUrl );
      Server.getDepartments().done( ( resp ) => {
        if (resp) {
          $.each( resp, ( index, item ) => {
            here.$myModal.find( '.letter-org' ).append( '<option value="' + item.id + '">' + item.name + '</option>' );
          } );
        }
      } );
    } );

    // 验证码点击事件,且注意接口后面需加一个随机参数才能每次点击获取到不同的图片，时间是最佳选择
    here.$pictureCheck.on( 'click', () => {
      let time = new Date().getTime();
      let imgUrl = Server.urls.img + '?time=' + time;
      here.$pictureCheck.attr( 'src', imgUrl );
    } );
  }

  // 点击左侧节点，赋值调接口，并且同步导航栏以及面包屑文字
  selectTreeNode( event, data ) {
    if (data.node.original.id !== null) {
      this.type = data.node.original.id;
      let text = data.node.text;
      let navText = '公开信箱 > ' + text;
      this.$keyword.html( '' );
      this.$bread.find( 'span' ).text( navText );
      this.$content.find( '.block__title' ).text( text );
    }
  }

  get treeData() {
    return treeData;
  }

  search() {
    let keywordValue = '';
    let endTime = '';
    let beginTime = ' ';
    let typeValue = null;
    let highKeywordValue = '';
    keywordValue = $( '#keyword' ).val();
    endTime = '';
    beginTime = '';
    typeValue = this.type;
    beginTime = this.$searchModal.find( '#replyDateStart' ).val();
    endTime = this.$searchModal.find( '#replyDateEnd' ).val();
    highKeywordValue = this.$searchModal.find( '#hl-keyword' ).val();
    if (keywordValue === null || keywordValue === undefined || keywordValue === '') {
      keywordValue = highKeywordValue;
    }
    const requestData = {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      begin: Date.parse( beginTime ) - ( 8 * 60 * 60 * 1000 ),
      end: Date.parse( endTime ) + ( ( 16 * 60 * 60 * 1000 ) - 1 ),
      keyword: keywordValue,
      type: typeValue
    };
    this.fetchData( requestData );
  }

  fetchData( requestData ) {
    this.client
        .searchMailList( requestData )
        .done( ( resp ) => {
          const total = resp.hits.total;
          const now = new Date().toDateString();
          // 遍历数据判断是否为新增
          resp.hits.hits.map( ( { _source } ) => {
            _source.isNew = new Date( _source.publishDate ).toDateString() === now;
            return _source;
          } );
          this.$content.find( '.block__content' ).html(
            listTpl( {
              _DATA_: resp.hits,
              _pageSize_: this.pageSize || '15'
            } )
          );
          this.$el.find( '.block__content .total' ).text( total );
          this.initPagination( total );
        } )
        .always( () => {
          // spinner.stop();
        } );
  }

  changeFileBox( change ) {
    let here = this;
    if (change) {
      here.$letterFiles.addClass( 'hidden' );
      here.$addLetterFiles.removeClass( 'hidden' );
      window.location.reload();
    } else {
      here.$addLetterFiles.addClass( 'hidden' );
      here.$letterFiles.removeClass( 'hidden' );
    }
  }

  getFileName( e ) {
    let name = e.target.files[ 0 ].name;
    let size = ( e.target.files[ 0 ].size / 1024 / 1024 ).toFixed( 1 );
    let $eFile = $( e.target ).parent().next();
    let $eName = $eFile.children( '.file-name' );
    // 判断文件大小
    if (size > 19) {
      alert( '附件过大，无法上传成功, 请重新上传' );
      let $row = $( e.target ).parent().parent();
      $row.remove();
      $('.letter-files .files-add .add-button').removeClass('gary');
    } else {
      $eName.html( name );
      $eName.attr( 'title', name );
    }
  }

  deleteFiles( e ) {
    let here = this;
    let $row = $( e.target ).parent().parent();
    $row.remove();
    here.$filesAdd.find( '.add-button' ).removeClass( 'gary' );
    here.$filesAdd.find( '.add-button' ).removeClass( 'disabled' );
  }

  addRows() {
    let here = this;
    let row = '<tr class="files"><td class="file-tr-file"><input type="file" name="attachments" class="file" /> <button type="button" class="choose-file">选择文件</button></td><td class="file-tr-name"><p type="text" class="file-name" title=""></p></td><td class="file-tr-do"><span class="delete-file">删除</span></td></tr>';
    let count = here.$letterFiles.find( '.files' ).length;
    if (count < 3) {
      here.$filesAdd.before( row );
      if (count == 2) {
        here.$filesAdd.find( '.add-button' ).attr( 'disabled', false );
        here.$filesAdd.find( '.add-button' ).addClass( 'gary' );
      }
    }
  }

  resetModal() {
    let here = this;
    let $infos = here.$myModal.find( 'input, textarea' );
    let $selects = here.$myModal.find( 'select' );
    $infos.each( ( i, el ) => {
      $( el ).val( '' );
    } );
    $selects.each( ( i, el ) => {
      $( el ).find( 'option:first' ).prop( 'selected', true );
    } );
    here.$letterFiles.addClass( 'hidden' );
    here.$addLetterFiles.removeClass( 'hidden' );
  }

  sendChecker() {
    let here = this;
    let isChecker = true;
    let $infos = here.$myModal.find( '.text-input,.letter-text,.letter-title,.picture-input' );
    if (isChecker) {
      $infos.each( ( i, el ) => {
        let info = $( el ).val();
        if (info == undefined || info == '' || info == null) {
          alert( '有内容未填，请完善后再尝试提交' );
          isChecker = false;
          return false;
        }
      } );
      if (isChecker) {
        let checkResult = here.infoChecker();
        if (checkResult) {
          return true;
        }
        return false;
      }
    } else {
      let checkResult = here.infoChecker();
      if (checkResult) {
        return true;
      }
      return false;
    }
  }

  infoChecker() {
    let here = this;
    let email = here.$email.val();
    let telPhone = here.$telPhone.val();
    // let t = /^0\d{2,3}-?\d{7,8}$/;
    let t = /^(1(3|4|5|7|8)\d{9})$|^(\d{3}-\d{7,8}|\d{4}-\d{7,8})$/;
    let e = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    if (!t.test( telPhone )) {
      alert( '请填写正确的联系方式' );
      return false;
    } else if (!e.test( email )) {
      alert( '请填写正确的邮箱' );
      return false;
    }
    return true;
    // here.ajaxSendLetter();
  }

  letterSearch( e ) {
    let here = this;
    if (here.$letterSearch.length !== 0) {
      let el = e.target || e.srcElement;
      let _val = $( el ).val() || '';
      if (_val.length > 0) {
        $( '.icon-Shape' ).show();
      } else {
        $( '.icon-Shape' ).hide();
      }
    }
  }

  clearSearchInput() {
    let here = this;
    here.$letterSearch.find( '#keyword' ).val( '' );
    $( '.icon-Shape' ).hide();
  }

  resetHighSearch() {
    let here = this;
    let $input = here.$searchModal.find( 'input' );
    let $dateInput = here.$date;
    $input.each( ( i, el ) => {
      $( el ).val( '' );
    } );
    $dateInput.val( '' );
  }

  // 发送信件事件
  ajaxSendLetter() {
    let here = this;
    let depart = here.$myModal.find( '.letter-org' ).val();
    let departNUm = parseInt( depart, 10 );
    let files = here.$myModal.find( '.file' )[ 0 ].files[ 0 ];
    // 这里漏掉了个人信息，rap 上没有，但是感觉应该是需要的
    const letterData = {
      name: here.$myModal.find( '.letter-name' ).val(),
      phone: here.$myModal.find( '.letter-tel' ).val(),
      company: here.$myModal.find( '.letter-unit' ).val(),
      content: here.$myModal.find( '.letter-text' ).val(),
      email: here.$myModal.find( '.letter-email' ).val(),
      sex: here.$myModal.find( '.letter-sex' ).val(),
      type: here.$myModal.find( '.letter-type' ).val(),
      departmentId: departNUm,
      attachments: files
    };
    Server.sendLetter( letterData ).done( ( resp ) => {
      if (resp) {
        alert( '发送成功' );
      }
    } );
  }

  // 获取信箱详情
  letterDetail( e ) {
    let here = this;
    let id = $( e.target ).context.dataset.id;
    Server.getLetterDetail( id ).done( ( resp ) => {
      if (resp) {
        here.$detailModal.find( '.modal-body' ).html( letterDetail( { _DATA_: resp._source } ) );
      }
    } );
  }

  // 发送信件事件
  submitMail() {
    let here = this;
    const $submit = here.$submitUploadForm;
    $submit.ajaxForm( {
      type: 'post',
      url: '/api/core/letter/create',
      contentType: 'application/json',
      dataType: 'json',
      iframeTarget: '#myFrame',
      beforeSubmit: () => {
        let checkResult = here.sendChecker();
        if (!checkResult) {
          return false;
        }
        here.isSubmit = true;
      },
      success: ( responseText ) => {
        if (responseText === true) {
          alert('提交成功');
          here.changeFileBox( true );
        } else {
          alert( responseText );
        }
        here.isSubmit = true;
      },
      error: ( data ) => {
        alert( '发送失败:' + data.responseText );
        here.isSubmit = true;
        this.$pictureInput.val( '' );
        here.$pictureCheck.trigger( 'click' );
      }
    } );
  }
}

module.exports = mailBox;

